import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useParams } from 'react-router-dom';
import { TEST_SOUSCRIPTION } from '../../Utils/constant';
import { store } from '../../services/service';
import { useStoreForfait } from '../../store/Paramettre/forfaitStore';
import { SubmitButton } from '../Widget/SubmitButton';

export const SouscriptionTest = () => {
    const [paiementChoix, setPaiementChoix] = useState("MOMO");
    const forfait = useStoreForfait()
    const [isSubmit, setIsSubmit] = useState(false)

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();
    useEffect(() => {
        forfait.forfait({ page: 0, param: "", size: 1000 })
    }, [])

    const { id } = useParams()

    const submit = (data) => {
        setIsSubmit(true)
        const requestData = { ...data, raccordementId: Number(id) }
        store(TEST_SOUSCRIPTION, 'application/json', requestData).then((res) => {
            if (res.status === 200) {
                toast.success('Test validé')
            }
        }).catch((err) => {
            setIsSubmit(false)
            toast.error(err?.response?.data?.donnee)
        })
    }
    return (
        <form onSubmit={handleSubmit(submit)} className="w-full flex flex-col  items-start  mt-6">
            <div className='w-full lg:w-96 items-start my-4 space-y-4'>
                <div className='my-2'>
                    <label className="form-control w-full">
                        <div className="label">
                            <span className="label-text text-sm font-semibold">Status du test</span>
                        </div>
                        <select
                            {...register("status", { required: true })}
                            className="select select-bordered w-full">
                            <option disabled selected>Selectionnez un status</option>
                            <option value={"EN_ATTENTE"}>En cours</option>
                            <option value={"REALISER"}>Realisé</option>
                        </select>
                    </label>
                </div>
                <div className='my-2'>
                    <label className="form-control w-full">
                        <div className="label">
                            <span className="label-text text-sm font-semibold">Resultat du test</span>
                        </div>
                        <select
                            {...register("resultat", { required: true })}
                            className="select select-bordered w-full">
                            <option disabled selected>Selectionnez un status</option>
                            <option value={'OK'}>OK</option>
                            <option value={'NON_OK'}>Non OK</option>
                        </select>
                    </label>
                </div>
                <label className="form-control  w-full">
                    <div className="label -mb-1">
                        <span className="label-text font-medium text-gray-400">
                            Débit constaté
                        </span>
                    </div>

                    <input
                        {...register("debit", { required: true })}
                        type="text"
                        placeholder="300 M/s"
                        className="input input-bordered text-gray-500 w-full h-10 text-sm font-semibold"
                    />
                </label>
                <div className='my-2'>
                    <label htmlFor="" className='text-sm font-medium'>Commentaire</label>
                    <textarea
                        {...register("commentaire")}
                        placeholder="Votre commentaire" className="textarea textarea-bordered textarea-sm w-full" ></textarea>
                </div>


            </div>

            <SubmitButton isSubmit={isSubmit} label={"Enregistrer"} />
        </form>
    )
}
